export default {
  title: 'Aspect comandă',
  form: {
    show_hero_image_with_offers: {
      label: 'Afișați imaginea principală cu oferte',
      description:
        'Implicit, adăugarea unei imagini de ofertă ascunde imaginea principală. Activați aceasta pentru a le afișa pe ambele.',
    },
  },
  buttons: {
    save: 'Salvați',
  },
  toasts: {
    failed_to_save_changes: 'Nu s-au putut salva modificările',
    changes_got_saved: 'Modificările au fost salvate',
  },
};
